function sockIn(name, type, defaultValue) {
  return defaultValue === void 0 ? { name, type } : { name, type, defaultValue };
}
function sockOut(name, type) {
  return { name, type };
}
function sigIn(name) {
  return { name, targets: [] };
}
function sigOut(name) {
  return { name, targets: [] };
}

export { sigIn, sigOut, sockIn, sockOut };
//# sourceMappingURL=sockets.js.map
